<template>
  <!--    贴图模板，素材的添加修改-->
  <div class="imageBox" v-loading="showLoading">
    <el-form ref="form" :model="images" label-width="80px">
      <div class="inputBox">
        <el-form-item label="预览图片">
          <div 
            class="upload-area" 
            @paste="handlePaste"
            @click="handleUploadThumbnailClick($event, 'file')"
            style="border: 2px dashed #d9d9d9; border-radius: 6px; padding: 10px; margin-bottom: 10px;"
          >
            <div style="color: #999; margin-bottom: 5px; font-size: 12px;">
              支持粘贴图片 (Ctrl+V) 或拖拽图片到弹窗任意位置
            </div>
            <el-upload
                v-if="!isUpdate"
                class="upload-demo"
                action="none"
                multiple
                accept="image/*"
                :limit="100"
                :file-list="images.fileList"
                :on-exceed="imageCountOut"
                :on-remove="handleRemove"
                :on-change="fileChange"
                :on-preview="handleUploadPreview"
                :before-upload="beforeUpload"
                :auto-upload="false"
                :list-type="isBatchMode ? 'picture-card' : 'picture'">
              <el-button v-if="!isBatchMode" size="small" type="primary">点击选择</el-button>
              <i v-else class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">
                {{ isBatchMode ? '批量模式：一次最多100张，单张不超过2MB' : '单张模式：只能上传一张图片，不超过50MB；选多张自动切换批量模式' }}
              </div>
            </el-upload>
            <el-upload
                v-else
                class="upload-demo"
                action="none"
                :limit="1"
                :file-list="images.fileList"
                :on-exceed="imageCountOut"
                :on-remove="handleRemove"
                :on-change="fileChange"
                :on-preview="handleUploadPreview"
                :auto-upload="false"
                list-type="picture">
              <el-button size="small" type="primary">点击选择</el-button>
              <div slot="tip" class="el-upload__tip">选择新图片将替换当前图片，且不超过50MB</div>
            </el-upload>
            <div v-if="!isUpdate && hasPngFiles" class="png-upload-warning">
              检测到 PNG 图片（{{ pngFileSummary }}），建议先转换为 WebP 再上传，体积更小、加载更快。
            </div>
          </div>
        </el-form-item>

        <el-alert
            v-if="isBatchMode"
            type="info"
            :closable="false"
            show-icon
            style="margin-bottom: 16px;"
            :title="'已选 ' + fileCount + ' 张，当前为批量上传模式'">
        </el-alert>

        <el-form-item v-if="!isBatchMode" label="是否加锁">
          <el-switch
              v-model="images.isLock"
              :active-value="1"
              :inactive-value="0"
              active-color="#67c23a"
              inactive-color="#dcdfe6">
          </el-switch>
        </el-form-item>

        <el-form-item v-if="!isBatchMode" label="图片标签">
          <el-input v-model="images.tag" class="input"></el-input>&nbsp;&nbsp;
          <template v-if="!isMaterialCollaborator">
            图片热度&nbsp;&nbsp;<el-input v-model="images.heat" class="input" type="number"></el-input>
          </template>
        </el-form-item>

        <el-form-item v-if="isBatchMode && !isUpdate" class="use-filename-tag-item">
          <span slot="label" class="use-filename-tag-label">使用图片名作为标签名</span>
          <el-switch
              v-model="isUseImageName"
              :active-value="true"
              :inactive-value="false"
              active-color="#67c23a"
              inactive-color="#dcdfe6">
          </el-switch>
        </el-form-item>

        <el-form-item v-if="isBatchMode && !isUpdate" label="公共标签">
          <el-input v-model="images.tag" class="input"></el-input>&nbsp;&nbsp;
          <template v-if="!isMaterialCollaborator">
            图片热度&nbsp;&nbsp;<el-input v-model="images.heat" class="input" type="number"></el-input>
          </template>
        </el-form-item>



<!--        <el-form-item label="图片分类">-->
<!--          <el-checkbox-group-->
<!--              style="margin-bottom:10px" -->
<!--          >-->
<!--            <el-checkbox label="A">贴图</el-checkbox>-->
<!--            <el-checkbox label="B">模板</el-checkbox>-->
<!--          </el-checkbox-group>-->
<!--        </el-form-item>-->

        <el-form-item label="素材类型">
          <el-radio-group v-model="images.categoryId" @change="handleCategoryChange">
            <el-radio-button :label="5">贴图</el-radio-button>
            <el-radio-button :label="4">模板</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-alert
            v-if="showTemplateBatchWarning"
            type="warning"
            :closable="false"
            show-icon
            style="margin-bottom: 16px;"
            title="批量上传模板时无法编辑图层数据、操作数据等，上传完成后请逐张编辑各模板">
        </el-alert>

        <el-form-item v-if="!isMaterialCollaborator && !isBatchMode" label="编辑模板图层数据">
          <el-button type="primary" size="small" @click="openTemplateLayerDataEditor">
            编辑模板图层数据
          </el-button>
        </el-form-item>

<!--        <el-form-item label="图片分类-旧方法">
          <el-cascader
              @change="selectChange"
              v-model="images.categoryIds"
              :options="categoryList"
              :props="{ value:'id',label:'categoryName',children:'childList'}">
          </el-cascader>
        </el-form-item>-->


        <el-form-item label="模板类型" v-if="hasShowOperation()">
          <el-select v-model="images.templateType" placeholder="请选择模板类型">
            <el-option
                v-for="item in templateType"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <div v-if="hasShowOperation()">
          <el-form-item label="操作数据" v-if="hasShowOperation()">
            <div class="upload-preview-wrap" @click="handleUploadThumbnailClick($event, 'material')">
              <el-upload
                  class="upload-demo"
                  action="none"
                  :limit="1"
                  :file-list="images.materialList"
                  :on-exceed="materialImageCountOut"
                  :on-remove="materialHandleRemove"
                  :on-change="materialFileChange"
                  :on-preview="handleUploadPreview"
                  :auto-upload="false"
                  list-type="picture">
                <el-button size="small" type="primary">点击选择</el-button>
                <div slot="tip" class="el-upload__tip">选择新文件将替换当前文件，且不超过50MB</div>
              </el-upload>
              <div style="margin-top: 5px;">
                <span style="font-size: 12px; color: #f56c6c; font-weight: bold; background: #fef0f0; padding: 2px 6px; border-radius: 3px; border: 1px solid #fbc4c4;">⚠️ 功能应该已过时</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="操作数据">
            <div style="display: flex; align-items: center; gap: 10px;">
              <div>
                <el-button type="primary" size="mini" @click="addFontData">添加文字数据</el-button>
                <el-button type="success" size="mini" @click="addImageData">添加图片数据</el-button>
              </div>
              <span style="font-size: 12px; color: #f56c6c; font-weight: bold; background: #fef0f0; padding: 2px 6px; border-radius: 3px; border: 1px solid #fbc4c4;">⚠️ 功能应该已过时</span>
            </div>
          </el-form-item>
          <div class="operationBox">
            <el-table
                :data="templateDataList"
                style="width: 100%">
              <el-table-column
                  width="80"
                  label="序号">
                <template slot-scope="scope">
                  <p>{{ scope.$index + 1 }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  width="80"
                  label="类型">
                <template slot-scope="scope">
                  <p>{{ scope.row.type === 1 ? "图片" : "文字" }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  prop="title"
                  label="标题"
                  width="150">
              </el-table-column>
              <el-table-column
                  prop="tips"
                  label="提示"
                  width="150">
              </el-table-column>
              <el-table-column
                  prop="left"
                  label="左边距"
                  width="50">
              </el-table-column>
              <el-table-column
                  prop="top"
                  label="上边距"
                  width="50">
              </el-table-column>
              <el-table-column
                  width="50"
                  prop="width"
                  label="宽度">
              </el-table-column>
              <el-table-column
                  width="50"
                  prop="height"
                  label="高度">
              </el-table-column>
              <el-table-column
                  width="50"
                  prop="rotateAngle"
                  label="旋转角度">
              </el-table-column>
              <el-table-column
                  width="80"
                  label="中间操作">
                <template slot-scope="scope">
                  <p>{{ getOperations(scope.row.middleOperation) }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  width="80"
                  label="文字方向">
                <template slot-scope="scope">
                  <p>{{ getFontLocation(scope.row.fontDirection) }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  width="50"
                  prop="fontSize"
                  label="文字大小">
              </el-table-column>
              <el-table-column
                  width="50"
                  prop="fontSum"
                  label="文字数量">
              </el-table-column>
              <el-table-column
                  width="150"
                  label="字体">
                <template slot-scope="scope">
                  <p>{{ scope.row.font !== null ? scope.row.font.name : "" }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  width="50"
                  prop="startTime"
                  label="开始时间(秒)">
              </el-table-column>
              <el-table-column
                  width="50"
                  prop="duration"
                  label="持续时间(秒)">
              </el-table-column>
              <el-table-column
                  fixed="right"
                  width="180"
                  align="center"
                  label="操作">
                <template slot-scope="scope">
                  <el-button type="primary" size="medium" icon="el-icon-edit"
                             @click="updateTemplateData(scope.row)"></el-button>
                  <el-button type="danger" size="medium" icon="el-icon-delete"
                             @click="delTemplateData(scope.row.id)"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <el-form-item class="btn">
        <!-- 防连点：保存进行中禁用，避免重复 updateImage / 重复建 template -->
        <el-button type="primary" :loading="showLoading" :disabled="showLoading" @click="save">保存</el-button>
        <el-button :disabled="showLoading" @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
    <el-dialog :title="dialogTitle"
               @close="closeDialog"
               top="5vh"
               @opened="dialogOpen"
               :visible.sync="showDialog"
               :close-on-click-modal="false"
               width="800px"
               append-to-body
               :destroy-on-close="true"
               :fullscreen="false">
      <TemplateDataAdd v-on:saveStatus="saveStatus"
                       :templateData="templateData"
                       :id="images.id"
                       :is-title="isTitle"
                       :type="images.templateType"
                       :is-load-data="isLoadDialog"
                       :is-add-image-data="isAddImageData"
                       :is-update="isUpdateTemplateData"/>
    </el-dialog>

    <!-- 编辑模板图层数据弹窗：关闭（含点 X）走 cancel，避免「暂无」文案误写进待保存数据 -->
    <el-dialog title="编辑模板图层数据"
               :visible.sync="showTemplateLayerDataDialog"
               :close-on-click-modal="false"
               width="80%"
               top="5vh"
               append-to-body
               :destroy-on-close="true"
               :fullscreen="false"
               @close="closeTemplateLayerDataDialog">
      <div class="template-layer-data-editor">
        <div style="margin-bottom: 10px;">
          <span style="color: #666; font-size: 12px;">
            {{ isValidJson ? '✓ 有效JSON格式' : '⚠ 非JSON格式' }}
          </span>
        </div>
        <el-input
          v-model="templateLayerData"
          type="textarea"
          :rows="20"
          placeholder="请输入模板图层数据..."
          style="width: 100%; font-family: 'Courier New', monospace;"
          @input="checkJsonFormat">
        </el-input>
        <div style="margin-top: 15px; text-align: right;">
          <el-button @click="closeTemplateLayerDataDialog">取消</el-button>
          <el-button type="primary" @click="saveTemplateLayerData">保存</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TemplateDataAdd from "./TemplateDataAdd";
import {openImagePreview, bindDialogFileDrop} from "./imageMaterialUtils";
import {mapState} from "vuex";

export default {
  name: "ImageEdit",
  props: ['images', "categoryList", "isUpdate", "loadData"],
  components: {
    TemplateDataAdd
  },
  computed: {
    ...mapState("userOptions", ["userInfo"]),
    isMaterialCollaborator() {
      return this.userInfo && this.userInfo.accountType === "material_collaborator"
    },
    fileCount() {
      if (this.isUpdate) {
        return this.images.file ? 1 : (this.images.fileList && this.images.fileList.length > 0 ? 1 : 0)
      }
      return this.images.files ? this.images.files.length : 0
    },
    isBatchMode() {
      return !this.isUpdate && this.fileCount >= 2
    },
    showTemplateBatchWarning() {
      return this.isBatchMode && this.images.categoryId === 4
    },
    pngFileNames() {
      if (this.isUpdate) {
        return []
      }
      const list = this.images.fileList || []
      const names = []
      for (let i = 0; i < list.length; i++) {
        const item = list[i]
        if (this.isPngFile(item.raw || item, item.name)) {
          names.push(item.name || (item.raw && item.raw.name) || ('图片' + (i + 1)))
        }
      }
      return names
    },
    hasPngFiles() {
      return this.pngFileNames.length > 0
    },
    pngFileSummary() {
      const names = this.pngFileNames
      if (names.length === 0) {
        return ''
      }
      if (names.length <= 3) {
        return names.join('、')
      }
      return names.slice(0, 3).join('、') + ' 等共 ' + names.length + ' 张'
    }
  },
  watch: {
    loadData: function (flag) {
      if (flag) {
        // 每次打开编辑弹窗清空暂存图层，避免上一张图的图层被带到本次保存
        this.originalTemplateLayerData = "";
        this.backupTemplateLayerData = "";
        this.initAddFormDefaults()
        this.getDataInfo()
      }
    }
  },
  data() {
    return {
      dialogTitle: "",
      showDialog: false,
      showLoading: false,
      postCount: 0,
      templateData: {},
      templateDataList: [],
      secondCategoryId: 2,
      isTitle: false,
      isUpdateTemplateData: false,
      isAddImageData: false,
      isLoadDialog: false,
      showTemplateLayerDataDialog: false,
      templateLayerData: "",
      originalTemplateLayerData: "", // 保存原始JSON数据
      backupTemplateLayerData: "", // 备份数据，用于取消时恢复
      isValidJson: false,
      isUseImageName: false,
      wasBatchMode: false,
      // 仅记住「自动填进去的文件名」，批量时只清这一份，用户手改过的标签不动
      autoFilledTagName: '',
      _imageReplaceUploadSeq: 0,
      templateType: [{
        label: "图片",
        value: 0
      }, {
        label: "视频",
        value: 1
      }]
    }
  },
  methods: {
    handleUploadPreview: function (file) {
      const url = file.url || ''
      if (!url) {
        return
      }
      openImagePreview(url, file.name || '图片预览')
    },
    handleUploadThumbnailClick: function (event, listKey) {
      if (event.target.closest('.el-icon-close, .el-upload-list__item-actions, .el-upload-list__item-name, .el-button')) {
        return
      }
      if (event.target.closest('.el-upload--picture-card') && !event.target.closest('.el-upload-list__item')) {
        return
      }
      const thumb = event.target.closest('.el-upload-list__item-thumbnail')
      if (!thumb) {
        return
      }
      event.preventDefault()
      event.stopPropagation()
      const file = this.findUploadFileByThumbnail(thumb, listKey)
      if (file) {
        this.handleUploadPreview(file)
      }
    },
    findUploadFileByThumbnail: function (thumb, listKey) {
      const list = listKey === 'material' ? this.images.materialList : this.images.fileList
      if (!list || !list.length) {
        return null
      }
      const src = thumb.getAttribute('src') || thumb.src || ''
      for (let i = 0; i < list.length; i++) {
        const fileUrl = list[i].url || ''
        if (fileUrl && (fileUrl === src || src.indexOf(fileUrl) === 0 || fileUrl.indexOf(src) === 0)) {
          return list[i]
        }
      }
      const item = thumb.closest('.el-upload-list__item')
      const listRoot = thumb.closest('.el-upload-list')
      if (!item || !listRoot) {
        return list[0]
      }
      const items = listRoot.querySelectorAll('.el-upload-list__item')
      let index = -1
      for (let j = 0; j < items.length; j++) {
        if (items[j] === item) {
          index = j
          break
        }
      }
      return index >= 0 ? list[index] : list[0]
    },
    initAddFormDefaults: function () {
      if (this.isUpdate) {
        return
      }
      this.isUseImageName = false
      this.wasBatchMode = false
      this.autoFilledTagName = ''
      if (this.images.heat === undefined || this.images.heat === null || this.images.heat === "") {
        this.$set(this.images, "heat", 4000)
      }
      if (this.images.categoryId === undefined || this.images.categoryId === null) {
        this.$set(this.images, "categoryId", 5)
      }
      if (this.images.categoryIds === undefined) {
        this.$set(this.images, "categoryIds", [1, 3, 5])
      }
      if (this.images.isLock === undefined) {
        this.$set(this.images, "isLock", 0)
      }
      if (this.images.files === undefined) {
        this.$set(this.images, "files", [])
      }
      if (this.images.fileList === undefined) {
        this.$set(this.images, "fileList", [])
      }
    },
    getFontLocation: function (location) {
      switch (location) {
        case "left":
          return "左边";
        case "right":
          return "右边";
        case "center":
          return "中间";
      }
      return "";
    },
    getOperations: function (operations) {
      switch (operations) {
        case "head":
          return "换头";
        case "face":
          return "抠脸";
      }
      return "无";
    },
    //是否显示操作选项（仅模板类素材）
    hasShowOperation: function () {
      if (!this.isUpdate) {
        return false
      }
      if (this.images.categoryId === 4) {
        return true
      }
      return this.images.secondCategory != null && this.images.secondCategory.id === 2
    },
    imageCountOut: function (files) {
      if (this.isUpdate) {
        if (files && files.length > 0) {
          this.processImageFile(files[0])
        }
        return
      }
      this.showErrorMessage("一次最多上传100张图片")
    },
    materialImageCountOut: function (files) {
      if (!files || files.length === 0) {
        return
      }
      this.processMaterialFile(files[0])
    },
    validateFileSize: function (file, batchMode) {
      const maxMb = batchMode ? 2 : 50
      const isLt = file.size / 1024 / 1024 < maxMb
      if (!isLt) {
        this.$message.error(batchMode ? '批量上传单张图片大小不能超过 2MB!' : '上传图片大小不能超过 50MB!')
      }
      return isLt
    },
    isPngFile: function (file, name) {
      const fileName = String(name || (file && file.name) || '').toLowerCase()
      const fileType = String((file && file.type) || '').toLowerCase()
      return fileType === 'image/png' || fileName.endsWith('.png')
    },
    beforeUpload: function (file) {
      return true
    },
    isTagEmpty: function () {
      const tag = this.images.tag
      return tag === '' || tag === undefined || tag === null || String(tag).trim() === ''
    },
    tryAutoFillTagFromImageName: function (fileName) {
      // 仅单张：把文件名填进标签输入框；批量靠开关 addFileNameToTag，不自动改公共标签
      if (this.isUpdate || !fileName || this.isBatchMode) {
        return
      }
      if (!this.isTagEmpty()) {
        return
      }
      const dotIndex = fileName.lastIndexOf('.')
      const tagName = dotIndex > 0 ? fileName.substring(0, dotIndex) : fileName
      if (tagName) {
        this.$set(this.images, 'tag', tagName)
        this.autoFilledTagName = tagName
      }
    },
    // 多选时 el-upload 会逐张 on-change，第一张当时 length 还是 1，会被误当成单张填进公共标签。只清这次自动填的，手改过的不动。
    clearAutoFilledTagIfBatch: function () {
      if (!this.autoFilledTagName) {
        return
      }
      if (this.images.tag === this.autoFilledTagName) {
        this.$set(this.images, 'tag', '')
      }
      this.autoFilledTagName = ''
    },
    syncFilesFromFileList: function (fileList) {
      this.$set(this.images, 'files', fileList.map(function (item) {
        return item.raw
      }))
      this.$set(this.images, 'fileList', fileList)
      if (fileList.length === 1) {
        this.$set(this.images, 'file', fileList[0].raw)
      } else {
        this.$set(this.images, 'file', null)
      }
    },
    scheduleTagByFileCount: function () {
      if (this._tagFillTimer) {
        clearTimeout(this._tagFillTimer)
      }
      const that = this
      this._tagFillTimer = setTimeout(function () {
        that._tagFillTimer = null
        if (that.isUpdate) {
          return
        }
        const list = that.images.fileList || []
        if (list.length >= 2) {
          that.clearAutoFilledTagIfBatch()
          return
        }
        if (list.length === 1 && that.isTagEmpty()) {
          that.tryAutoFillTagFromImageName(list[0].name)
        }
      }, 0)
    },
    onFileCountChanged: function (fileList) {
      let nextList = fileList
      const isBatch = nextList.length >= 2
      if (isBatch) {
        const validList = nextList.filter(function (item) {
          return this.validateFileSize(item.raw || item, true)
        }.bind(this))
        if (validList.length !== nextList.length) {
          this.$message.warning('批量模式下单张不能超过2MB，已移除不符合要求的文件')
          nextList = validList
          this.syncFilesFromFileList(nextList)
        }
      }
      if (!this.wasBatchMode && isBatch && nextList.length >= 2) {
        this.$message.info('已切换为批量上传模式')
        this.isUseImageName = false
      } else if (this.wasBatchMode && nextList.length < 2) {
        this.$message.info('已切换为单张上传模式')
        this.isUseImageName = false
      }
      this.wasBatchMode = nextList.length >= 2
      // 多张：公共标签保持空。单张仍用文件名填，但等多选这一轮回调结束再填，避免先吃到第一张文件名。
      if (!this.isUpdate && nextList.length >= 2) {
        this.clearAutoFilledTagIfBatch()
      }
      this.scheduleTagByFileCount()
      if (nextList.length >= 2 && this.images.categoryId === 4) {
        this.$message.warning('批量上传模板时无法编辑图层数据、操作数据等，上传完成后请逐张编辑各模板')
      }
    },
    /**
     * 图片移除回调
     * @param file
     * @param fileList
     */
    handleRemove: function (file, fileList) {
      if (file.url && file.url.startsWith('blob:')) {
        URL.revokeObjectURL(file.url);
      }
      if (this.isUpdate) {
        this.images.file = null
        return
      }
      this.syncFilesFromFileList(fileList)
      this.onFileCountChanged(fileList)
    },
    /**
     * 图片移除回调
     * @param file
     * @param fileList
     */
    materialHandleRemove: function (file, fileList) {
      // 清理URL对象
      if (file.url && file.url.startsWith('blob:')) {
        URL.revokeObjectURL(file.url);
      }
      this.images.materialFile = null
    },
    cancel: function () {
      this.$emit('saveStatus', false)
    },
    /**
     * 保存上传
     * */
    save() {
      // 请求进行中禁止再次进入，防止连点重复提交
      if (this.showLoading) {
        return
      }
      if (!this.isUpdate && this.hasPngFiles) {
        const that = this
        this.$confirm(
          '检测到 PNG 图片（' + this.pngFileSummary + '）。建议先转换为 WebP 再上传，体积更小、加载更快。是否仍要继续上传？',
          '检测到 PNG 格式',
          {
            confirmButtonText: '仍要上传',
            cancelButtonText: '返回修改',
            type: 'warning',
            center: true
          }
        ).then(function () {
          that.doSave()
        }).catch(function () {})
        return
      }
      this.doSave()
    },
    doSave() {
      if (this.showLoading) {
        return
      }
      if (!this.isUpdate) {
        if (this.isBatchMode) {
          this.addBatchImages()
        } else {
          this.addSingleImage()
        }
      } else {
        this.update()
      }
    },
    fileChange: function (file, fileList) {
      if (this.isUpdate) {
        this.images.file = file.raw
        this.uploadReplacedImage(file.raw)
        return
      }

      const isBatch = fileList.length >= 2
      if (!this.validateFileSize(file, isBatch)) {
        const nextList = fileList.filter(function (item) {
          return item.uid !== file.uid
        })
        this.syncFilesFromFileList(nextList)
        return
      }

      this.syncFilesFromFileList(fileList)
      this.onFileCountChanged(fileList)
    },
    /**
     * 图片选择回调
     * @param file
     * @param fileList
     */
    materialFileChange: function (file, fileList) {
      this.images.materialFile = file.raw
      let type = file.raw.name.substring(file.raw.name.lastIndexOf('.'))
      if (type === ".mp4") {
        this.$set(this.images, "templateType", 1)
      } else {
        this.$set(this.images, "templateType", 0)
      }

    },

    handleCategoryChange(newVal) {
      const newSecondCategoryId = newVal === 4 ? 2 : 3
      this.$set(this, 'secondCategoryId', newSecondCategoryId)
      if (!this.isUpdate && this.isBatchMode && newVal === 4) {
        this.$message.warning('批量上传模板时无法编辑图层数据、操作数据等，上传完成后请逐张编辑各模板')
      }
    },

    selectChange: function (data) {
      console.log("selectChange" + data)
      //匹配三级id
      if (data !== undefined) {
        if (data.length === 3) {
          this.images.categoryId = data[2]
        }
        if (data.length >= 2) {
          this.secondCategoryId = data[1];
        }
        console.log("categoryId " + this.images.categoryId)
      }
    },
    /**
     * 显示错误信息弹框
     * @param msg 错误信息弹框
     */
    showErrorMessage: function (msg) {
      this.$confirm(msg, "提示", {
        confirmButtonText: '确定',
        showClose: false,
        showCancelButton: false,
        center: true,
        type: 'error'
      })
    },
    /**
     * 上传图片
     */
    addSingleImage: function () {
      if (this.images.tag === '' || this.images.tag === undefined) {
        this.showErrorMessage("图片名不能为空")
        return
      }
      if (this.images.heat === undefined || this.images.heat === "") {
        this.showErrorMessage("热度不能为空")
        return
      }
      if (this.images.categoryId === null || this.images.categoryId === undefined) {
        this.showErrorMessage("分类必须是三级分类")
        return
      }
      if (this.images.file === null || this.images.file === undefined) {
        this.showErrorMessage("图片不能为空")
        return
      }
      this.showLoading = true;
      const that = this;
      const params = new FormData()
      params.append("file", this.images.file)
      params.append("tag", this.images.tag)
      params.append("hot", this.images.heat)
      params.append("categoryId", this.images.categoryId)
      params.append("isLock", this.images.isLock !== undefined ? this.images.isLock : 0)
      this.$request.post("/images/addImage", params)
          .then(function (data) {
            that.showLoading = false
            if (data.status === 200) {
              that.$message.success("添加成功");
              that.$emit('saveStatus', true)
            } else {
              that.showErrorMessage(data.message)
            }
          }).catch(function (err) {
        that.showLoading = false
        that.$confirm("网络错误", "提示", {
          confirmButtonText: '确定',
          showClose: false,
          showCancelButton: false,
          center: true,
          type: 'error'
        })
      })
    },
    addBatchImages: function () {
      if ((this.images.tag === '' || this.images.tag === undefined) && !this.isUseImageName) {
        this.showErrorMessage("公共标签不能为空，请输入公共标签或打开使用图片名作为标签名")
        return
      }
      if ((this.images.tag === '' || this.images.tag === undefined) && this.isUseImageName) {
        this.images.tag = ""
      }
      if (this.images.heat === undefined || this.images.heat === "") {
        this.showErrorMessage("热度不能为空")
        return
      }
      if (this.images.categoryId === null || this.images.categoryId === undefined) {
        this.showErrorMessage("请选择素材类型")
        return
      }
      if (!this.images.files || this.images.files.length < 2) {
        this.showErrorMessage("请至少选择两张图片")
        return
      }
      for (let i = 0; i < this.images.files.length; i++) {
        if (!this.validateFileSize(this.images.files[i], true)) {
          return
        }
      }
      this.showLoading = true;
      const that = this;
      const params = new FormData()
      params.append("tag", this.images.tag)
      params.append("hot", this.images.heat)
      params.append("categoryId", this.images.categoryId)
      params.append("isLock", 0)
      params.append("addFileNameToTag", this.isUseImageName)
      params.append("imageType", "")
      for (let i = 0; i < this.images.files.length; i++) {
        params.append("files", this.images.files[i])
      }
      this.$request.post("/images/uploadImages", params, {
        timeout: 180000,
      })
          .then(function (data) {
            that.showLoading = false
            if (data.status === 200) {
              that.$confirm("添加成功", "提示", {
                confirmButtonText: '确定',
                showClose: false,
                showCancelButton: false,
                center: true,
                type: 'success'
              }).then(function () {
                that.$emit('saveStatus', true)
              })
            } else {
              that.showErrorMessage(data.message)
            }
          }).catch(function (err) {
        that.showLoading = false
        that.$confirm("网络错误", "提示", {
          confirmButtonText: '确定',
          showClose: false,
          showCancelButton: false,
          center: true,
          type: 'error'
        })
      })
    },
    buildUpdateImageFormData: function (file) {
      const params = new FormData()
      params.append("id", this.images.id)
      if (file) {
        params.append("file", file)
      }
      params.append("tag", this.images.tag)
      params.append("isLock", this.images.isLock)
      params.append("hot", this.images.heat)
      params.append("categoryId", this.images.categoryId)
      if (this.images.materialFile) {
        params.append("materialImage", this.images.materialFile)
      }
      if (this.images.templateType !== undefined && this.images.templateType !== "") {
        params.append("templateType", this.images.templateType)
      }
      return params
    },
    uploadReplacedImage: function (file) {
      if (!this.isUpdate || !file) {
        return
      }
      if (!this.validateFileSize(file, false)) {
        return
      }
      if (this.images.heat === undefined || this.images.heat === "") {
        this.showErrorMessage("热度不能为空")
        return
      }
      const seq = ++this._imageReplaceUploadSeq
      const that = this
      this.$request.post("/images/updateImage", this.buildUpdateImageFormData(file))
          .then(function (data) {
            if (seq !== that._imageReplaceUploadSeq) {
              return
            }
            if (data.status === 200) {
              that.images.file = null
              if (data.data && data.data.url) {
                that.$set(that.images, 'url', data.data.url)
                if (that.images.fileList && that.images.fileList.length > 0) {
                  const oldUrl = that.images.fileList[0].url
                  if (oldUrl && oldUrl.startsWith('blob:')) {
                    URL.revokeObjectURL(oldUrl)
                  }
                  that.$set(that.images.fileList[0], 'url', data.data.url)
                }
              }
              that.$message.success("图片上传成功")
            } else {
              that.showErrorMessage(data.message)
            }
          }).catch(function () {
            if (seq !== that._imageReplaceUploadSeq) {
              return
            }
            that.$message.error("图片上传失败")
          })
    },
    update: function () {
      if (this.showLoading) {
        return
      }
      if (this.images.heat === undefined || this.images.heat === "") {
        this.showErrorMessage("热度不能为空")
        return
      }
      const that = this;
      const params = this.buildUpdateImageFormData(this.images.file)

      // 先锁住保存，防连点重复写图片/图层
      this.showLoading = true
      // 先保存图片信息
      this.$request.post("/images/updateImage", params)
          .then(function (data) {
            if (data.status === 200) {
              that.images.file = null
              // 仅当用户在「编辑模板图层数据」里显式暂存过真实内容时才写图层；空/占位不写
              if (that.originalTemplateLayerData && that.originalTemplateLayerData.trim() !== ""
                  && that.originalTemplateLayerData.trim() !== "暂无模板图层数据") {
                that.updateTemplateLayerDataToBackend();
              } else {
                that.showLoading = false
                that.$message.success("修改成功");
                that.$emit('saveStatus', true)
              }
            } else {
              that.showLoading = false
              that.showErrorMessage(data.message)
            }
          }).catch(function (err) {
        that.showLoading = false
        that.$confirm("网络错误", "提示", {
          confirmButtonText: '确定',
          showClose: false,
          showCancelButton: false,
          center: true,
          type: 'error'
        })
      })
    },
    //添加文字信息
    addFontData: function () {
      this.dialogTitle = "添加文字信息"
      this.isAddImageData = false
      this.showDialog = true
    },
    //添加图片信息
    addImageData: function () {
      this.dialogTitle = "添加图片信息"
      this.isAddImageData = true
      this.showDialog = true
    },
    closeDialog: function () {
      this.templateData = {}
      this.isUpdateTemplateData = false
      this.isAddImageData = false
      this.isLoadDialog = false
    },
    /**
     * 数据保存状态
     * @param info
     */
    saveStatus: function (info) {
      if (info !== false) {
        this.getDataInfo()
      }
      this.showDialog = false
    },
    getDataInfo: function () {
      if (!this.hasShowOperation()) {
        return
      }
      const params = new URLSearchParams()
      const that = this
      params.append("id", this.images.id)
      this.$request.post("/autoTemplate/getAutoTemplateDataList", params)
          .then(function (data) {
            that.templateDataList = data.data
          }).catch(function () {})
    },
    updateTemplateData: function (data) {
      this.isUpdateTemplateData = true
      this.templateData = data
      if (data.type === 1) {
        this.dialogTitle = "修改图片信息"
        this.showDialog = true
      } else {
        this.dialogTitle = "修改文本信息"
        this.showDialog = true
      }
    },
    delTemplateData: function (id) {
      this.showLoading = true
      const params = new URLSearchParams()
      const that = this;
      params.append("id", id)
      this.$request.post("/autoTemplate/delAutoTemplateById", params)
          .then(function (data) {
            that.showLoading = false
            if (data.status === 200) {
              that.$message.success("删除成功");
              that.getDataInfo()
            } else {
              that.showMessage(data.message)
            }
          }).catch(function (err) {
        that.showLoading = false
        that.showMessage("网络错误")
      })
    },
    dialogOpen: function () {
      this.isLoadDialog = true
    },
    /**
     * 处理粘贴事件
     * @param event
     */
    handlePaste: function (event) {
      const items = event.clipboardData.items;
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          const file = items[i].getAsFile();
          if (file) {
            this.processImageFile(file);
          }
          break;
        }
      }
    },
    /**
     * 处理拖拽事件
     * @param event
     */
    handleDrop: function (event) {
      event.preventDefault();
      const files = event.dataTransfer.files;
      if (this.isUpdate) {
        if (files.length > 0) {
          const file = files[0];
          if (file.type.startsWith('image/')) {
            this.processImageFile(file);
          } else {
            this.showErrorMessage("请拖拽图片文件");
          }
        }
        return
      }
      const imageFiles = Array.from(files).filter(function (f) {
        return f.type.startsWith('image/')
      })
      if (imageFiles.length === 0) {
        this.showErrorMessage("请拖拽图片文件")
        return
      }
      this.processImageFiles(imageFiles)
    },
    /**
     * 处理图片文件
     * @param file
     */
    processImageFile: function (file) {
      this.processImageFiles([file])
    },
    processImageFiles: function (files) {
      if (this.isUpdate) {
        if (files.length > 0) {
          this.processImageFileLegacy(files[0])
        }
        return
      }

      const currentList = this.images.fileList ? this.images.fileList.slice() : []
      const willBeBatch = currentList.length + files.length >= 2
      const added = []

      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        if (!file.type.startsWith('image/')) {
          continue
        }
        if (currentList.length + added.length >= 100) {
          this.$message.warning("最多只能上传100张图片")
          break
        }
        if (!this.validateFileSize(file, willBeBatch)) {
          continue
        }
        const url = URL.createObjectURL(file)
        added.push({
          name: file.name || ('pasted_image_' + Date.now() + '.png'),
          size: file.size,
          type: file.type,
          raw: file,
          url: url,
          uid: Date.now() + i
        })
      }

      if (added.length === 0) {
        return
      }

      const nextList = currentList.concat(added)
      this.syncFilesFromFileList(nextList)
      this.onFileCountChanged(nextList)
      this.$message.success('已添加 ' + added.length + ' 张图片')
    },
    processImageFileLegacy: function (file) {
      // 检查文件大小
      if (file.size > 50 * 1024 * 1024) {
        this.showErrorMessage("图片文件不能超过50MB");
        return;
      }
      
      // 检查文件类型
      if (!file.type.startsWith('image/')) {
        this.showErrorMessage("请选择图片文件");
        return;
      }

      if (this.images.fileList && this.images.fileList.length > 0) {
        this.images.fileList.forEach(function (f) {
          if (f.url && f.url.startsWith('blob:')) {
            URL.revokeObjectURL(f.url);
          }
        });
      }
      
      // 创建预览URL
      const url = URL.createObjectURL(file);
      
      // 创建文件对象
      const fileObj = {
        name: file.name || `pasted_image_${Date.now()}.png`,
        size: file.size,
        type: file.type,
        raw: file,
        url: url,
        uid: Date.now() // 添加唯一标识，帮助 el-upload 识别
      };
      
      // 使用 $set 更新文件列表，确保响应式更新
      this.$set(this.images, 'fileList', [fileObj]);
      this.$set(this.images, 'file', file);
      
      if (this.isUpdate) {
        this.uploadReplacedImage(file)
        return
      }

      // 如果是新增模式，标签为空且只有一张图片时自动设置标签名
      this.tryAutoFillTagFromImageName(fileObj.name)
      this.$message.success("图片添加成功");
    },
    processMaterialFile: function (file) {
      if (file.size > 50 * 1024 * 1024) {
        this.showErrorMessage("文件不能超过50MB");
        return;
      }
      if (this.images.materialList && this.images.materialList.length > 0) {
        this.images.materialList.forEach(function (f) {
          if (f.url && f.url.startsWith('blob:')) {
            URL.revokeObjectURL(f.url);
          }
        });
      }
      const url = URL.createObjectURL(file);
      const fileObj = {
        name: file.name,
        size: file.size,
        type: file.type,
        raw: file,
        url: url,
        uid: Date.now()
      };
      this.$set(this.images, 'materialList', [fileObj]);
      this.images.materialFile = file;
      const ext = file.name.substring(file.name.lastIndexOf('.'));
      this.$set(this.images, "templateType", ext === ".mp4" ? 1 : 0);
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    /**
     * 打开模板图层数据编辑器
     */
    openTemplateLayerDataEditor: function() {
      // 备份当前的originalTemplateLayerData，用于取消时恢复
      this.backupTemplateLayerData = this.originalTemplateLayerData;
      // false=未确认暂存；点弹窗内「保存」后为 true，@close 时不再恢复备份
      this._templateLayerCommitted = false;
      this.showTemplateLayerDataDialog = true;
      // 获取模板图层数据
      this.getTemplateLayerData();
    },
    /**
     * 关闭模板图层数据编辑器（取消按钮 / 点 X / destroy）
     * 未点弹窗内「保存」则恢复备份，防止「暂无」或半成品写进待保存数据
     */
    closeTemplateLayerDataDialog: function() {
      if (!this._templateLayerCommitted) {
        this.originalTemplateLayerData = this.backupTemplateLayerData;
      }
      this.showTemplateLayerDataDialog = false;
      this.templateLayerData = "";
      this.isValidJson = false;
    },
    /**
     * 获取模板图层数据（只填编辑框展示，不改动待保存的 originalTemplateLayerData）
     * 无数据时编辑框留空，避免「暂无模板图层数据」被当成真实图层写库
     */
    getTemplateLayerData: function() {
      if (!this.images.id) {
        this.$message.error("图片ID不能为空");
        return;
      }
      
      this.showLoading = true;
      const that = this;
      const params = new URLSearchParams();
      params.append("imageId", this.images.id);
      
      console.log("发送获取模板图层数据请求，imageId:", this.images.id);
      
      this.$request.post("/template/getTemplateLayerData", params)
        .then(function(data) {
          console.log("获取模板图层数据响应:", data);
          that.showLoading = false;
          if (data.status === 200 && data.data) {
            that.templateLayerData = data.data;
            that.checkJsonFormat();
            if (that.isValidJson) {
              that.formatJson();
            }
          } else {
            // 无 template 行或图层为空：编辑框空着，等用户粘贴；不污染 originalTemplateLayerData
            that.templateLayerData = "";
            that.isValidJson = false;
            if (data.status !== 200) {
              that.$message.warning(data.message || "暂无模板图层数据，可粘贴后保存");
            }
          }
        })
        .catch(function(err) {
          console.error("获取模板图层数据错误:", err);
          that.showLoading = false;
          that.templateLayerData = "";
          that.isValidJson = false;
          that.$message.error("获取数据失败: " + (err.message || "网络错误"));
        });
    },
    
    /**
     * 暂存模板图层数据（不保存到后端）
     * 只有用户在这里点了保存，外层保存才会带图层去写库
     */
    saveTemplateLayerData: function() {
      const raw = this.templateLayerData ? this.templateLayerData.trim() : "";
      // 空内容或占位文案一律不暂存，避免「没有图层」被写成「有图层」
      if (!raw || raw === "暂无模板图层数据") {
        this.$message.error("模板图层数据不能为空");
        return;
      }
      
      // 将格式化后的数据转换回压缩格式暂存（不格式化）
      if (this.isValidJson) {
        try {
          const obj = JSON.parse(this.templateLayerData);
          this.originalTemplateLayerData = JSON.stringify(obj); // 压缩格式
        } catch (e) {
          this.originalTemplateLayerData = this.templateLayerData;
        }
      } else {
        this.originalTemplateLayerData = this.templateLayerData;
      }
      
      this.$message.success("模板图层数据已暂存！点击下方【保存】按钮完成最终保存");
      // 先标记已确认，再关弹窗，避免 @close 把暂存内容恢复成备份
      this._templateLayerCommitted = true;
      this.showTemplateLayerDataDialog = false;
      this.templateLayerData = "";
      this.isValidJson = false;
    },
    
    /**
     * 保存模板图层数据到后端
     * createIfAbsent=true：仅此管理后台路径允许「无 template 行则新建」；其它调用不传则只 UPDATE
     */
    updateTemplateLayerDataToBackend: function() {
      const that = this;
      const params = new URLSearchParams();
      params.append("imageId", this.images.id);
      params.append("layerDataList", this.originalTemplateLayerData);
      // 显式允许无记录时新建，避免改通用接口默认行为
      params.append("createIfAbsent", "true");
      
      console.log("保存模板图层数据到后端，imageId:", this.images.id);
      
      this.$request.post("/template/updateTemplateLayerData", params)
        .then(function(data) {
          console.log("保存模板图层数据响应:", data);
          
          if (data.status === 200) {
            // 已落库则清暂存，防止确认 CDN 期间再点保存导致重复提交/重复建行
            that.originalTemplateLayerData = "";
            // 保存成功后，询问是否立即刷新CDN（期间保持 showLoading，按钮继续禁用）
            that.$confirm("是否立即刷新模板数据CDN？\n（不刷新会隔日自动刷新）", "提示", {
              confirmButtonText: '立即刷新',
              cancelButtonText: '暂不刷新',
              type: 'success',
              center: true
            }).then(function () {
              // 用户选择立即刷新
              that.refreshSingleTemplateCdnAfterSave();
            }).catch(function () {
              // 用户选择稍后刷新
              that.showLoading = false;
              that.$message.info("模板数据将在隔日自动刷新CDN");
              that.$emit('saveStatus', true);
            });
          } else {
            that.showLoading = false;
            that.$message.error("模板图层数据保存失败: " + (data.message || ""));
          }
        })
        .catch(function(err) {
          that.showLoading = false;
          console.error("保存模板图层数据错误:", err);
          that.$message.error("模板图层数据保存失败: " + (err.message || "网络错误"));
        });
    },
    
    /**
     * 检查JSON格式
     */
    checkJsonFormat: function() {
      if (!this.templateLayerData || this.templateLayerData.trim() === "") {
        this.isValidJson = false;
        return;
      }
      
      try {
        JSON.parse(this.templateLayerData);
        this.isValidJson = true;
      } catch (e) {
        this.isValidJson = false;
      }
    },
    
    /**
     * 格式化JSON
     */
    formatJson: function() {
      if (!this.isValidJson) {
        this.$message.warning("请先输入有效的JSON数据");
        return;
      }
      
      try {
        const obj = JSON.parse(this.templateLayerData);
        this.templateLayerData = JSON.stringify(obj, null, 2);
        this.$message.success("JSON格式化完成");
      } catch (e) {
        this.$message.error("JSON格式化失败: " + e.message);
      }
    },
    
    /**
     * 保存成功后刷新单个模板的CDN数据
     */
    refreshSingleTemplateCdnAfterSave: function() {
      if (!this.images.id) {
        this.$message.error("图片ID不能为空");
        return;
      }
      
      this.showLoading = true;
      const that = this;
      const params = new URLSearchParams();
      params.append("imageId", this.images.id);
      
      this.$request.post("/test/refreshSingleTemplateCdn", params)
        .then(function(data) {
          that.showLoading = false;
          if (data.status === 200) {
            that.$message.success("CDN刷新成功！");
            // 刷新成功后关闭编辑弹窗，刷新列表
            that.$emit('saveStatus', true);
          } else {
            that.$message.error(data.message || "CDN刷新失败");
            // 即使刷新失败，也关闭弹窗（数据已经保存成功了）
            that.$emit('saveStatus', true);
          }
        })
        .catch(function(err) {
          that.showLoading = false;
          // 修复错误处理
          let errorMsg = "CDN刷新请求失败";
          if (err && err.message) {
            errorMsg = "CDN刷新失败: " + err.message;
          } else if (err && err.response && err.response.data && err.response.data.message) {
            errorMsg = err.response.data.message;
          }
          that.$message.error(errorMsg);
          // 即使刷新失败，也关闭弹窗（数据已经保存成功了）
          that.$emit('saveStatus', true);
        });
    }
  },
  mounted() {
    this.initAddFormDefaults()
    const that = this
    this.$nextTick(function () {
      that._dialogDropBind = bindDialogFileDrop(that.$el, {
        onDrop: function (event) {
          that.handleDrop(event)
        }
      })
    })
  },
  beforeDestroy() {
    if (this._dialogDropBind) {
      this._dialogDropBind.unbind()
      this._dialogDropBind = null
    }
    // 清理创建的URL对象
    if (this.images.fileList && this.images.fileList.length > 0) {
      this.images.fileList.forEach(file => {
        if (file.url && file.url.startsWith('blob:')) {
          URL.revokeObjectURL(file.url);
        }
      });
    }
  }
}
</script>

<style scoped>
.imageBox {
  width: 100%;
  min-height: 300px;
}

.inputBox {
  max-height: 600px;
  overflow-y: scroll;
  margin-bottom: 20px;
  padding-bottom: 20px;
}

.inputBox::-webkit-scrollbar {
  display: none;
}

.btn /deep/ .el-form-item__content {
  margin-left: 0 !important;
  text-align: center;
}

.png-upload-warning {
  margin-top: 10px;
  padding: 8px 12px;
  color: #f56c6c;
  background: #fef0f0;
  border: 1px solid #fbc4c4;
  border-radius: 4px;
  font-size: 13px;
  line-height: 1.5;
  font-weight: 600;
}

.input {
  width: 300px;
}

.use-filename-tag-label {
  white-space: nowrap;
}

.use-filename-tag-item /deep/ .el-form-item__label {
  white-space: nowrap;
  overflow: visible;
  width: auto !important;
}

.upload-area /deep/ .el-upload-list__item-thumbnail,
.upload-preview-wrap /deep/ .el-upload-list__item-thumbnail {
  cursor: zoom-in;
}

.upload-area /deep/ .el-upload-list__item,
.upload-area /deep/ .el-list-enter-active,
.upload-area /deep/ .el-list-leave-active,
.upload-area /deep/ .el-list-move {
  transition: none !important;
}

.upload-area /deep/ .el-progress {
  display: none;
}

.operationBox {
  width: 100%;
}

/* 模板图层数据编辑器样式 */
.template-layer-data-editor {
  font-family: 'Courier New', monospace;
}

.template-layer-data-editor /deep/ .el-textarea__inner {
  font-family: 'Courier New', monospace;
  line-height: 1.4;
  white-space: pre-wrap;
  word-break: break-all;
}

.template-layer-data-editor /deep/ .el-textarea__inner:focus {
  border-color: #409EFF;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}
</style>
